import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-two-columns-column__content" }
const _hoisted_2 = {
  key: 0,
  class: "page-two-columns-column__before"
}
const _hoisted_3 = {
  "data-v-sticky-container": "",
  class: "page-two-columns-column__sticky-container"
}
const _hoisted_4 = { class: "page-two-columns-column__inner" }
const _hoisted_5 = {
  class: "page-two-columns-column__inner",
  "data-v-sticky-inner": ""
}
const _hoisted_6 = {
  key: 1,
  class: "page-two-columns-column__after"
}
const _hoisted_7 = { class: "page-two-columns-column__content" }
const _hoisted_8 = {
  key: 0,
  class: "page-two-columns-column__before"
}
const _hoisted_9 = { class: "page-two-columns-column__inner" }
const _hoisted_10 = {
  key: 1,
  class: "page-two-columns-column__after"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_sticky = _resolveDirective("sticky")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrapperTag), {
    class: _normalizeClass(["page-two-columns", _ctx.cssClass]),
    onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['left', 'right'], (col, colIdx) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: col }, [
          (_ctx.isSticky(col))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["page-two-columns-column page-two-columns__column", `page-two-columns__column--${col}`])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  (_ctx.hasSlot(`${col}-before`))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, `${col}-before`, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isiOS)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          ref_for: true,
                          ref: el => _ctx.setListRef(el, colIdx),
                          class: "page-two-columns-column__sticky page-two-columns-column__sticky--native"
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, col, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                          ])
                        ], 512))
                      : _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: 1,
                          ref_for: true,
                          ref: el => _ctx.setListRef(el, colIdx),
                          class: "page-two-columns-column__sticky"
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, col, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                          ])
                        ])), [
                          [_directive_sticky, _ctx.stickyOptions]
                        ])
                  ]),
                  (_ctx.hasSlot(`${col}-after`))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, `${col}-after`, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["page-two-columns-column page-two-columns__column", `page-two-columns__column--${col}`])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.hasSlot(`${col}-before`))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _renderSlot(_ctx.$slots, `${col}-before`, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, col, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                  ]),
                  (_ctx.hasSlot(`${col}-after`))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _renderSlot(_ctx.$slots, `${col}-after`, _normalizeProps(_guardReactiveProps({ updateSidebar: _ctx.updateSidebar })))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
        ], 64))
      }), 64))
    ]),
    _: 3
  }, 8, ["class", "onSubmit"]))
}